module.exports = __webpack_public_path__ + "static/media/outline-format_align_center-24px.473edf91.svg";